import { Avatar } from "antd";
import React from "react";
import { useAuthStore } from "../../store/AuthStore";

const UserOwner = () => {
  const { userData } = useAuthStore();

  return (
    <>
      {userData && (
        <div>
          <div
            className="subheader"
            style={{
              position: "relative",
            }}
          >
            <div
              className="blog-owner container-fluid max-w-screen-xl m-auto pb-5"
              style={{ padding: "0 21" }}
            >
              <div className="myProfile">
                <Avatar
                  size={130}
                  icon={`${userData.firstName[0]} ${
                    userData.lastName ? userData.lastName[0] : ""
                  }`}
                  src={userData.profileImage}
                />

                <div className="details">
                  <h1 className="blogownerTitle blog-com-title">
                    {userData.firstName} {userData.lastName ?? ""}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx="true">
        {`
          .view {
            color: #ffffff;
            font-family: Lato;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 17px;
            text-align: center;
            background-color: #4299e1;
            padding: 12px 27px;
            border-radius: 22.5px;
          }
          @media only screen and (max-width: 768px) {
            .view {
              padding: 12px 25px; 
          }
        `}
      </style>
    </>
  );
};

export default UserOwner;
